import { handleActions } from 'redux-actions';

export let SET_MODAL = 'gdc/SET_MODAL';

let initialState = {
  Component: null,
  style: {},
  meta: {},
};

export let setModal = payload => ({
  type: SET_MODAL,
  payload,
});

export default handleActions({
  [SET_MODAL]: (state, action) => {
    return {
      style: action.payload.style,
      meta: action.payload.meta,
      Component: action.payload.Component
    };
  }
}, initialState);
